import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import LotteryApi from '../../Api/SiteApi/LotteryApi';
import { AllCountersData, CounterData } from '../../Api/SiteApi/Response/LotteryApi';

import { useGlobalStoreSelector } from '../GlobalStore';

import FetchInterface from './FetchInterface';
import LoadingInterface from './LoadingInterface';

const fetchCounters = createAsyncThunk(
    'lotteryCounters/fetch',
    async (): Promise<AllCountersData | []> => {
        return LotteryApi.getAllCountersData().catch((err: AxiosError) => {
            console.error('An error occurred while fetching counters data.', err.message);

            return [];
        });
    }
);

interface LotteryCountersInterface extends FetchInterface {
    counters: AllCountersData | [];
}

const LotteryCountersSlice = createSlice<LotteryCountersInterface, SliceCaseReducers<LotteryCountersInterface>>({
    name: 'lotteryCounters',
    initialState: {
        isLoading: false,
        isFetched: false,
        counters: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCounters.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCounters.fulfilled, (state, action) => {
            state.counters = action.payload;
            state.isLoading = false;
            state.isFetched = true;
        });
    },
});

export default LotteryCountersSlice.reducer;

export const useLotteryCounter = function (lotterySlug: string): LoadingInterface & { counter: CounterData | null } {
    const dispatch = useDispatch();

    const { counters, isLoading, isFetched } = useGlobalStoreSelector((state) => state.lotteryCounters);

    useEffect(() => {
        if (!isFetched && !isLoading) {
            dispatch(fetchCounters());
        }
    }, [dispatch]);

    let counter = null;
    if (!Array.isArray(counters)) {
        counter = counters[lotterySlug] || null;
    }

    return {
        counter,
        isLoading,
    };
};
